import { TimelineChannel } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import {
  IconBell,
  IconMail,
  IconMessageCircle,
  IconMessageSquare,
  IconPhone,
} from '@avantstay/backoffice-vectors'

import { getChannelInfo, getChannelLabel } from '../../helpers/channelTone'
import * as S from './ChannelTag.styles'

interface ChannelTagProps {
  channel: TimelineChannel
  medium?: string | null
}

const ICONS = {
  sms: IconMessageSquare,
  other: IconMessageCircle,
  voyage: IconMessageCircle,
  email: IconMail,
  chat: IconMessageCircle,
  ota: IconMessageCircle,
  push: IconBell,
  call: IconPhone,
}

export const ChannelTag = ({ channel, medium }: ChannelTagProps) => {
  const info = getChannelInfo(channel, medium)
  const Icon = ICONS[info.tone]

  return (
    <S.Root $tone={info.tone}>
      <Icon />
      {getChannelLabel(info)}
    </S.Root>
  )
}
